<template>
    <svg width="26" height="22" viewBox="0 0 26 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M2.1958 12.1828L10.0259 20.0128L23.8046 2.26758" stroke="#00BF8C" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
</template>
